import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanName',
  standalone: false
})
export class CleanNamePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    const search = /servicio al cliente|caja/g;
    const cleaned = value.toLocaleLowerCase().match(search)?.[0];
    const result = cleaned ? cleaned : value;
    const capitalizedParagraph = result.replace(/^\w/, (c) => c.toUpperCase());
    return capitalizedParagraph;
  }
}
